module.exports = __webpack_public_path__ + "pc/img/img_about_03.18e615e6.webp";